import styled, { css } from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';
import HeaderBackgroundImage from '../../images/facility-tour/kitchen-header@2x.jpg';
import KitchenHeroImage from '../../images/facility-tour/kitchen@2x.jpg';
import FoundationHeader from '../../images/facility-tour/foundation-header@2x.jpg';
import SubfloorHeader from '../../images/facility-tour/subfloor-header@2x.jpg';
import PlumbingHeader from '../../images/facility-tour/plumbing-header@2x.jpg';
import FlooringHeader from '../../images/facility-tour/flooring-header@2x.jpg';
import WallsHeader from '../../images/facility-tour/walls-header@2x.jpg';
import RoofHeader from '../../images/facility-tour/roof-header@2x.jpg';
import ExteriorHeader from '../../images/facility-tour/exterior-header@2x.jpg';
import InspectionsHeader from '../../images/facility-tour/inspections-header@2x.jpg';
import PierBeamFoundation from '../../images/facility-tour/pier-beam-foundation@2x.jpg';
import HomeSiteHeader from '../../images/facility-tour/home-site-header@2x.jpg';
import CdTopArrow from '../../images/facility-tour/cd-top-arrow.svg';
import Grid from '../../images/facility-tour/grid.svg';
import zIndices, {
  setBelow,
  setSameAs,
} from 'pubweb-smokey/dist/components/zIndex';

let zIndicies = {
  entireComponent: setBelow(zIndices.dropDownMenuModal), // sets the z-index to below what dropDownMenuModal's
  navMenuItemsDesktop: setSameAs(), // sets the z-index to be the same as previous one
  navLogoBurgerMobile: setSameAs(), // sets the z-index to be the same as previous one
  navMenuItemsMobile: setBelow(), // sets the z-index to be below the previous one
};

const backgroundPhotoStyles = css`
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 264px;
  position: relative;
  width: 100%;

  @media (min-width: 768px) {
    height: 316px;
  }

  @media (min-width: 1200px) {
    height: 500px;
  }
`;

const FacilityTourStyles = styled.div`
  font-family: 'acumin-pro', sans-serif;

  a {
    text-decoration: none;
  }

  .lazy-load-image-background.blur.lazy-load-image-loaded {
    display: unset !important;
  }

  .facility-tour-header-wrap {
    background-image: url(${HeaderBackgroundImage});
    ${backgroundPhotoStyles}

    @media (min-width: 1200px) {
      height: 609px;
    }
  }

  .width-wrapper {
    width: 100%;
  }

  .interactive-btn {
    background: ${Colors.primary.claytonBlue.standard};
    border-radius: 6px;
    text-decoration: none;
    color: white;
    font: 600 14px/100% acumin-pro, sans-serif;
    padding: 20px 0;
    width: 200px;
    display: block;
    text-align: center;
    margin: 10px auto 0;

    &:hover {
      opacity: 0.9;
      cursor: pointer;
    }
  }

  .facility-tour-header-wrap__title {
    color: white;
    display: block;
    font-size: 40px;
    font-weight: bold;
    letter-spacing: -3.6px;
    padding: 20px 0;
    text-align: center;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

    @media (min-width: 768px) {
      font-size: 69px;
      padding: 10px;
    }
  }

  .facility-tour-header-wrap__sub-title {
    color: white;
    display: block;
    font-size: 32px;
    font-weight: bold;
    left: 50%;
    letter-spacing: -1.5px;
    line-height: 1;
    margin: 0 auto;
    max-width: 1140px;
    position: absolute;
    text-align: center;
    top: 50%;
    width: 80%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);

    @media (min-width: 450px) {
      font-size: 40px;
    }

    @media (min-width: 768px) {
      font-size: 55px;
      line-height: 0.9;
    }

    @media (min-width: 1023px) {
      font-size: 80px;
    }
  }

  .facility-tour-header-wrap__text-wrap {
    left: 50%;
    position: absolute;
    top: 50%;
    width: 80%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }

  .facility-tour-header-wrap__blurb {
    color: white;
    display: block;
    font-size: 20px;
    letter-spacing: -1px;
    line-height: 1.03;
    padding: 20px 0;
    text-align: center;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

    @media (min-width: 768px) {
      font-size: 33px;
    }
  }

  .facility-tour-content-wrap {
    display: block !important;
    margin: 0 auto;
    max-width: 1140px;
    padding: 20px 0 60px;
    width: 90%;

    @media (min-width: 768px) {
      padding: 40px 20px 60px;
      width: 100%;
    }

    @media (min-width: 1023px) {
      padding: 60px 20px 146px;
      width: 100%;
    }

    &.no-place-like-home {
      padding: 40px 0;

      @media (min-width: 450px) {
        padding: 40px 20px;
      }

      @media (min-width: 768px) {
        padding: 0 20px 60px;
        width: 100%;
      }

      @media (min-width: 1200px) {
        padding: 31px 20px 115px;
        width: 100%;
      }
    }
  }

  .facility-tour-section__section-title {
    color: #090909;
    display: block;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.2;
    padding-bottom: 20px;
    margin: 0 auto;
    text-align: center;

    @media (min-width: 1023px) {
      font-size: 30px;
    }
  }

  .facility-tour-section__blurb {
    color: #090909;
    display: block;
    font-size: 20px;
    font-weight: 300;
    line-height: 1.5;
    padding-bottom: 40px;
    margin: 0 auto;
    text-align: center;
    width: 90%;

    @media (min-width: 1023px) {
      font-size: 30px;
      line-height: 1.2;
      padding-bottom: 70px;
      width: 74%;
    }

    @media (min-width: 1200px) {
      width: 65%;
    }
  }

  .nav-dropdown-button-wrap {
    width: 100%;
    padding: 0 20px;
  }

  .facility-tour-nav-mobile {
    display: block;
    margin: 0 auto;
    padding-top: 20px;
    position: relative;
    width: 100%;

    @media (min-width: 768px) {
      display: none;
    }
  }

  .dropdown-chevron {
    border-style: solid;
    border-width: 2.5px 2.5px 0 0;
    color: #9c9c9c;
    float: right;
    height: 9px;
    position: relative;
    right: 5%;
    top: 5px;
    vertical-align: bottom;
    width: 9px;
    transform: rotate(138deg);
    -ms-transform: rotate(138deg);
    &.flip {
      transform: rotate(-45deg);
      -ms-transform: rotate(-45deg);
    }
  }

  .facility-tour-nav-dropdown {
    background: transparent;
    border: none;
    color: #9c9c9c;
    display: block;
    float: left;
    font-size: 15px;
    height: 27px;
    text-align: left;
    &:hover {
      color: ${Colors.primary.claytonBlue.standard};
    }
  }

  .dropdown-facility-tour-content {
    display: none;
    margin: 0 10px 0 20px;
    padding-bottom: 10px;
    transition: margin 600ms ease;
    a {
      display: block;
      padding: 7px 0;
      text-align: left;
    }

    &.closed {
      margin-top: -400px;
    }

    &.open {
      display: block;
    }
  }

  .facility-tour-nav-wrap {
    display: none;

    @media (min-width: 768px) {
      display: block;
      padding: 40px 0 20px 0;
    }
  }

  .facility-tour-nav {
    margin: 0 auto;
    max-width: 1140px;
    text-align: center;
  }

  .facility-tour-nav__option {
    color: #9c9c9c;
    font-size: 15px;
    font-weight: bold;
    letter-spacing: -0.1px;
    line-height: 1.6;
    margin: 0 5px;
    text-align: center;
    &:hover {
      color: ${Colors.primary.claytonBlue.standard};
    }
  }

  .border-line {
    border: 1px solid #f0f0f0;
    width: 100%;
  }

  .facility-tour-page__blurb {
    margin: 0 auto;
    padding: 20px 0;
    max-width: 767px;

    @media (min-width: 768px) {
      margin-top: 30px;
    }
  }

  .facility-tour-section__small-blurb {
    color: #8a8a8a;
    display: block;
    font-size: 11px;
    font-weight: 300;
    line-height: 1.1;
    margin-bottom: 40px;
    margin-top: -15px;
    text-align: left;

    @media (min-width: 768px) {
      margin-top: -13px;
      padding: 0 19px;
    }
  }

  .facility-tour-page__blurb__header {
    color: black;
    display: block;
    font-size: 30px;
    font-weight: bold;
    letter-spacing: -1.5px;
    line-height: 1.2;
    margin-bottom: 30px;
    text-align: center;

    @media (min-width: 768px) {
      font-size: 36px;
      line-height: 0.75;
    }
  }

  .facility-tour-page__blurb__body {
    color: black;
    display: block;
    font-size: 20px;
    font-weight: 200;
    line-height: 1.45;
    text-align: center;

    @media (min-width: 1023px) {
      font-size: 22px;
    }
  }

  .kitchen-hero {
    ${backgroundPhotoStyles}
    ${backgroundPhotoStyles}
    background-image: url(${KitchenHeroImage});
    height: 267px;

    @media (min-width: 768px) {
      height: 322px;
    }

    @media (min-width: 1023px) {
      height: 506px;
    }
  }

  .brands-wrap {
    display: block;
    margin: 0 auto;
    width: 100%;

    @media (min-width: 768px) {
      padding-top: 30px;
    }

    @media (min-width: 1200px) {
      padding: 30px 20px 0;
    }
  }

  .brands-wrap__title {
    color: black;
    display: block;
    font-size: 36px;
    font-weight: bold;
    letter-spacing: -1.5px;
    line-height: 0.75;
    padding-bottom: 40px;
    text-align: left;

    @media (min-width: 768px) {
      float: left;
      width: 50%;
    }
  }

  .brands-wrap__logos {
    align-items: center;
    display: inline-block;
    margin-bottom: 40px;
    width: 100%;

    @media (min-width: 601px) {
      justify-content: flex-start;
    }

    @media (min-width: 768px) {
      float: left;
      width: 50%;
    }
  }

  .brands-wrap__logo {
    box-sizing: content-box;
    display: inline-block;
    padding: 10px;
    width: 87px;
    vertical-align: middle;

    @media (min-width: 768px) {
      margin-top: -15px;
      padding: 22px 10px;
    }

    @media (min-width: 1023px) {
      padding: 18px;
      width: 115px;
    }

    @media (min-width: 1200px) {
      padding: 26px 22px;
      width: 140px;
    }

    & img {
      display: block;
      margin: 0 auto;
    }
  }

  .brands-wrap__photos {
    display: block !important;
    margin: 0 auto;
    img {
      box-sizing: border-box;
      display: block;
      height: auto;
      margin: 0 auto;
      padding: 10px;
      max-width: 450px;
      width: 100%;

      @media (min-width: 768px) {
        float: left;
        width: 33%;
      }
    }
  }

  .foundation-wrap-header {
    ${backgroundPhotoStyles}
    ${backgroundPhotoStyles}
    background-image: url(${FoundationHeader});
  }

  .subfloor-wrap-header {
    ${backgroundPhotoStyles}
    ${backgroundPhotoStyles}
    background-image: url(${SubfloorHeader});
  }

  .plumbing-wrap-header {
    ${backgroundPhotoStyles}
    ${backgroundPhotoStyles}
    background-image: url(${PlumbingHeader});
  }

  .flooring-wrap-header {
    ${backgroundPhotoStyles}
    ${backgroundPhotoStyles}
    background-image: url(${FlooringHeader});
  }

  .walls-wrap-header {
    ${backgroundPhotoStyles}
    ${backgroundPhotoStyles}
    background-image: url(${WallsHeader});
  }

  .roof-wrap-header {
    ${backgroundPhotoStyles}
    ${backgroundPhotoStyles}
    background-image: url(${RoofHeader});
  }

  .exterior-wrap-header {
    ${backgroundPhotoStyles}
    ${backgroundPhotoStyles}
    background-image: url(${ExteriorHeader});
  }

  .inspections-wrap-header {
    ${backgroundPhotoStyles}
    ${backgroundPhotoStyles}
    background-image: url(${InspectionsHeader});
  }

  #energysmart {
    @media (min-width: 768px) {
      padding-top: 152px;
    }

    @media (min-width: 1200px) {
      padding-top: 152px;
    }
  }

  .energysmart-wrap-header {
    display: none;

    ${backgroundPhotoStyles}
    ${backgroundPhotoStyles}

    @media (min-width: 768px) {
      background-image: url(${Grid});
      display: block;
      position: relative;
    }
  }

  .energysmart-wrap-header-mobile {
    @media (min-width: 768px) {
      display: none;
    }
  }

  .pierbeam-wrap-header {
    ${backgroundPhotoStyles}
    ${backgroundPhotoStyles}
    background-image: url(${PierBeamFoundation});
    & span {
      width: 60%;
    }
  }

  .homesite-wrap-header {
    ${backgroundPhotoStyles}
    ${backgroundPhotoStyles}
    background-image: url(${HomeSiteHeader});
  }

  .facility-tour-section__photo-wrap {
    display: block !important;
    margin: 0 auto;
    &.two-photos {
      .facility-tour-section__photo-content {
        box-sizing: border-box;
        display: block;
        margin: 0 auto;
        max-width: 380px;
        width: 100%;

        @media (min-width: 768px) {
          float: left;
          max-width: none;
          padding: 0 19px;
          width: 50%;
        }

        @media (min-width: 1200px) {
          padding: 0 50px;
        }
      }

      .facility-tour-section__photo-content-photo {
        display: block !important;
        height: auto;
        margin: 0 auto;
        max-width: none;
        width: 100%;

        @media (min-width: 1200px) {
          height: 365px;
          width: 519px;
        }
      }
    }

    &.three-photos {
      .facility-tour-section__photo-content {
        box-sizing: border-box;
        display: block;
        max-width: 320px;
        margin: 0 auto;
        width: 100%;

        @media (min-width: 768px) {
          float: left;
          max-width: none;
          padding: 0 14px;
          width: 33%;
        }

        @media (min-width: 1200px) {
          padding: 0 22px;
        }
      }

      .facility-tour-section__photo-content-photo {
        display: block !important;
        height: auto;
        margin: 0 auto;
        max-width: none;
        width: 100%;

        @media (min-width: 1200px) {
          height: 394px;
          width: 351px;
        }
      }
    }
  }

  .facility-tour-section__photo-content-blurb {
    color: black;
    display: block;
    font-size: 17px;
    font-weight: 300;
    line-height: 1.35;
    margin: 15px 0 35px;
    text-align: left;

    @media (min-width: 768px) {
      margin: 40px 0 20px;
    }

    &.blurb-title {
      font-weight: bold;
      margin: 20px 0 10px;
    }

    &.sub {
      margin-top: 18px;
    }

    &.list {
      margin-top: -14px;
    }

    &.list li {
      display: list-item;
      list-style-type: disc !important;
      margin-left: 18px;
    }
  }

  .facility-tour-section__photo-content-blurb-centered {
    color: black;
    display: block;
    font-size: 17px;
    font-weight: 300;
    line-height: 1.35;
    margin: 0 auto;
    padding: 20px 0 40px;
    text-align: center;

    @media (min-width: 768px) {
      padding: 40px 0;
    }
  }

  .facility-tour-section__photo-content-small-blurb {
    color: #8a8a8a;
    display: block;
    font-size: 11px;
    font-weight: 300;
    line-height: 1.1;
    text-align: left;
  }

  .esh-logo-mobile {
    display: block;
    margin: 0 auto;
    max-width: 350px;
    width: 60%;
  }

  .esh-image-mobile {
    display: block;
    margin: 0 auto;
    max-width: 500px;
    width: 80%;
  }

  .disclaimer-wrap {
    margin: 0 auto;
    max-width: 1140px;
    width: 100%;
  }

  .esh-disclaimer {
    color: $semiBolBlack;
    display: block;
    font-size: 10px;
    margin: -12px 20px 10px;
    &.mobile {
      @media (min-width: 768px) {
        display: none;
      }
    }

    &.desktop {
      display: none;

      @media (min-width: 768px) {
        bottom: 2%;
        display: block;
        position: absolute;
      }
    }
  }

  .asterisk-blue {
    color: #00aef2;
  }

  .esh-image-desktop {
    display: none;

    @media (min-width: 768px) {
      display: block;
      left: 50%;
      max-width: 1000px;
      padding-bottom: 150px;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 80%;
    }
  }

  .esh-details-mobile {
    display: block;
    margin: 50px 40px;
    & li {
      display: list-item;
      font-size: 17px;
      font-weight: 300;
      line-height: 1.35;
      list-style-type: disc !important;
      margin-left: 18px;
      text-transform: capitalize;
    }

    @media (min-width: 768px) {
      display: none;
    }
  }

  .energysmart-background {
    background-color: #44a7f1;
  }

  .energy-smart-wrap {
    padding: 60px 0 40px;

    @media (min-width: 768px) {
      padding: 60px 0 0;
    }

    @media (min-width: 1023px) {
      margin-bottom: -90px;
      padding: 86px 0 0;
    }
  }

  .energy-smart-section-left {
    color: white;
    margin: 0 auto;
    padding-bottom: 60px;
    text-align: left;

    @media (min-width: 768px) {
      float: left;
      padding-bottom: 0;
      width: 50%;
    }
  }

  .energy-smart-section-right {
    color: white;
    margin: 0 auto;
    text-align: left;

    @media (min-width: 768px) {
      float: right;
      width: 50%;
    }
  }

  .energy-smart-section__headline {
    display: block;
    font-size: 30px;
    font-weight: bold;
    letter-spacing: -1.5px;
    line-height: 1.11;
    margin-bottom: 30px;

    @media (min-width: 768px) {
      font-size: 36px;
    }
  }

  .energy-smart-section__body {
    font-size: 22px;
    font-weight: 200;
    line-height: 1.23;
    padding-bottom: 20px;
    color: white;

    @media (min-width: 768px) {
      width: 80%;
    }
  }

  .energy-graph {
    display: block;
    padding: 40px;

    @media (min-width: 768px) {
      margin: 20px 0;
    }
  }

  .energy-smart-section__footnote {
    font-size: 11px;
    font-weight: 300;
    line-height: 1.2;
    padding-bottom: 20px;
    color: white;
  }

  .facility-tour-section__photo-section {
    display: block !important;
    margin: 0 auto;
    padding-top: 20px;

    @media (min-width: 768px) {
      padding: 50px 14px 0;
    }

    @media (min-width: 1023px) {
      padding: 50px 22px 0;
    }
  }

  .facility-tour-section__photo-section-photo {
    display: block !important;
    height: auto;
    margin: 0 auto;
    max-width: 450px;
    width: 100%;

    @media (min-width: 768px) {
      float: left;
      width: 50%;
    }
  }

  .facility-tour-section__photo-section-blurb {
    display: block;
    margin: 0 auto;
    max-width: 450px;
    padding: 10px 0;

    @media (min-width: 768px) {
      float: left;
      margin-left: 40px;
      padding: 0;
    }

    &.list li {
      display: list-item;
      font-size: 20px;
      font-weight: 300;
      line-height: 1.67;
      list-style-type: disc !important;
      margin-left: 18px;
      text-align: left;
      width: 100%;

      @media (min-width: 768px) {
        line-height: 2;
      }

      @media (min-width: 1023px) {
        font-size: 30px;
        line-height: 1.67;
      }
    }
  }

  .bottom-cta {
    ${backgroundPhotoStyles}
    background-image: url(${FlooringHeader});
    background-position: top center;
    min-height: 264px;

    @media (min-width: 1023px) {
      min-height: 650px;
    }
  }

  .clearfix:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: ' ';
    clear: both;
    height: 0;
  }

  .clearfix {
    display: inline-block;
  }

  .no-wrap {
    white-space: nowrap;
  }

  img {
    height: auto;
    max-width: 100%;
  }

  .cd-top {
    display: inline-block;
    height: 40px;
    width: 40px;
    border-radius: 4px;
    position: fixed;
    bottom: 100px;
    right: 10px;
    z-index: 10;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    /* image replacement properties */
    overflow: hidden;
    text-indent: 100%;
    white-space: nowrap;
    background: ${Colors.primary.claytonBlue.standard} url(${CdTopArrow})
      no-repeat center 50%;
    visibility: hidden;
    opacity: 0;
    -webkit-transition: opacity 0.3s 0s, visibility 0s 0.3s;
    -moz-transition: opacity 0.3s 0s, visibility 0s 0.3s;
    transition: opacity 0.3s 0s, visibility 0s 0.3s;
  }

  .cd-top.cd-is-visible,
  .cd-top.cd-fade-out,
  .no-touch .cd-top:hover {
    -webkit-transition: opacity 0.3s 0s, visibility 0s 0s;
    -moz-transition: opacity 0.3s 0s, visibility 0s 0s;
    transition: opacity 0.3s 0s, visibility 0s 0s;
  }

  .cd-top.cd-is-visible {
    /* the button becomes visible */
    visibility: visible;
    opacity: 1;
  }

  .cd-top.cd-fade-out {
    /* if the user keeps scrolling down, the button is out of focus and becomes less visible */
    opacity: 0.5;
  }

  .no-touch .cd-top:hover {
    background-color: ${Colors.primary.claytonBlue.standard};
    opacity: 1;
  }

  @media only screen and (min-width: 768px) {
    .cd-top {
      right: 20px;
      bottom: 20px;
    }
  }

  @media only screen and (min-width: 1024px) {
    .cd-top {
      height: 61px;
      width: 61px;
      right: 30px;
      bottom: 30px;
    }
  }
`;

export default FacilityTourStyles;
